module.exports = __webpack_public_path__ + "img/num-top.5bafccc3.svg";